const currentUserID = localStorage.getItem('user_id');

const currentUserRights = localStorage.getItem('rights');



export {currentUserID, currentUserRights}